import { formatDate, formatOsis } from "../utils/format-utils";

export default class ClientRoster {
  planId: number | null;
  clientId?: number | null;
  clientFirstName?: string | null;
  clientLastName?: string | null;
  dateOfBirth?: Date | null;
  osis?: string | null;
  zipCode?: string | null;
  districtAdminId?: number | null;
  districtAdminFirstName?: string | null;
  districtAdminLastName?: string | null;
  districtId?: number | null;
  schoolId?: number | null;
  schoolName?: string | null;
  teamId?: number | null;
  teamName?: string | null;
  planTypeId?: number | null;
  planType?: string | null;
  ageCategoryId?: number | null;
  ageCategory?: string | null;
  planStartDate?: Date | null;
  planMeetingDate?: Date | null;
  planClosureDate?: Date | null;
  nextMeetingScheduledDate?: Date | null;
  planScheduleType?: string | null;
  isSummerSemesterIncluded?: boolean | null;
  languageId?: number | null;
  language?: string | null;
  servicePlanId?: number | null;
  programId?: number | null;
  programCode?: string | null;
  serviceId?: number | null;
  serviceCode?: string | null;
  servicePlanStartDate?: Date | null;
  servicePlanEndDate?: Date | null;
  groupSize?: number | null;
  frequency?: number | null;
  durationMinutes?: number | null;
  sessionLocationId?: number | null;
  location?: string | null;
  unitCount?: number | null;
  semesterId?: number | null;
  semesterCode?: string | null;
  registrationStart?: Date | null;
  registrationEnd?: Date | null;
  assignmentId?: number | null;
  providerId?: number | null;
  legacyProviderId?: string | null;
  providerFirstName?: string | null;
  providerLastName?: string | null;
  approvalStartDate?: Date | null;
  approvalEndDate?: Date | null;
  actualStartDate?: Date | null;
  actualEndDate?: Date | null;
  providerSpecGroupSize?: number | null;
  providerSpecFrequency?: number | null;
  providerSpecDurationMinutes?: number | null;
  providerSpecLocationId?: number | null;
  providerSpecLocation?: string | null;
  firstAttendDate?: Date | null;
  firstAttendDateSubmittedAt?: Date | null;
  isActivePlan?: boolean | null;
  isExpiringServicePlan?: boolean | null;
  isExpiringAssignment?: boolean | null;
  isPartialMandate?: boolean | null;
  isContinuingRegistration?: boolean | null;
  public constructor(params: ClientRoster = {} as ClientRoster) {
    let {
      planId = null,
      clientId = null,
      clientFirstName = "",
      clientLastName = "",
      dateOfBirth = null,
      osis = "",
      zipCode = "",
      districtAdminId = null,
      districtAdminFirstName = "",
      districtAdminLastName = "",
      districtId = null,
      schoolId = null,
      schoolName = "",
      teamId = null,
      teamName = "",
      planTypeId = null,
      planType = "",
      ageCategoryId = null,
      ageCategory = "",
      planStartDate = null,
      planMeetingDate = null,
      planClosureDate = null,
      nextMeetingScheduledDate = null,
      planScheduleType = "",
      isSummerSemesterIncluded = null,
      languageId = null,
      language = "",
      servicePlanId = null,
      programId = null,
      programCode = "",
      serviceId = null,
      serviceCode = "",
      servicePlanStartDate = null,
      servicePlanEndDate = null,
      groupSize = null,
      frequency = null,
      durationMinutes = null,
      sessionLocationId = null,
      location = "",
      unitCount = null,
      semesterId = null,
      semesterCode = "",
      registrationStart = null,
      registrationEnd = null,
      assignmentId = null,
      providerId = null,
      legacyProviderId = "",
      providerFirstName = "",
      providerLastName = "",
      approvalStartDate = null,
      approvalEndDate = null,
      actualStartDate = null,
      actualEndDate = null,
      providerSpecGroupSize = null,
      providerSpecFrequency = null,
      providerSpecDurationMinutes = null,
      providerSpecLocationId = null,
      providerSpecLocation = "",
      firstAttendDate = null,
      firstAttendDateSubmittedAt = null,
      isContinuingRegistration = false,
      isActivePlan = false,
      isExpiringServicePlan = false,
      isExpiringAssignment = false,
      isPartialMandate = false,
    } = params;
    this.planId = planId;
    this.clientId = clientId;
    this.clientFirstName = clientFirstName;
    this.clientLastName = clientLastName;
    this.dateOfBirth = dateOfBirth;
    this.osis = osis;
    this.zipCode = zipCode;
    this.districtAdminId = districtAdminId;
    this.districtAdminFirstName = districtAdminFirstName;
    this.districtAdminLastName = districtAdminLastName;
    this.districtId = districtId;
    this.schoolId = schoolId;
    this.schoolName = schoolName;
    this.teamId = teamId;
    this.teamName = teamName;
    this.planTypeId = planTypeId;
    this.planType = planType;
    this.ageCategoryId = ageCategoryId;
    this.ageCategory = ageCategory;
    this.planStartDate = planStartDate;
    this.planMeetingDate = planMeetingDate;
    this.nextMeetingScheduledDate = nextMeetingScheduledDate;
    this.planClosureDate = planClosureDate;
    this.planScheduleType = planScheduleType;
    this.isSummerSemesterIncluded = isSummerSemesterIncluded;
    this.languageId = languageId;
    this.language = language;
    this.servicePlanId = servicePlanId;
    this.programId = programId;
    this.programCode = programCode;
    this.serviceId = serviceId;
    this.serviceCode = serviceCode;
    this.servicePlanStartDate = servicePlanStartDate;
    this.servicePlanEndDate = servicePlanEndDate;
    this.groupSize = groupSize;
    this.frequency = frequency;
    this.durationMinutes = durationMinutes;
    this.sessionLocationId = sessionLocationId;
    this.location = location;
    this.unitCount = unitCount;
    this.semesterId = semesterId;
    this.semesterCode = semesterCode;
    this.registrationStart = registrationStart;
    this.registrationEnd = registrationEnd;
    this.assignmentId = assignmentId;
    this.providerId = providerId;
    this.legacyProviderId = legacyProviderId;
    this.providerFirstName = providerFirstName;
    this.providerLastName = providerLastName;
    this.approvalStartDate = approvalStartDate;
    this.approvalEndDate = approvalEndDate;
    this.actualStartDate = actualStartDate;
    this.actualEndDate = actualEndDate;
    this.providerSpecGroupSize = providerSpecGroupSize;
    this.providerSpecFrequency = providerSpecFrequency;
    this.providerSpecDurationMinutes = providerSpecDurationMinutes;
    this.providerSpecLocationId = providerSpecLocationId;
    this.providerSpecLocation = providerSpecLocation;
    this.firstAttendDate = firstAttendDate;
    this.firstAttendDateSubmittedAt = firstAttendDateSubmittedAt;
    this.isContinuingRegistration= isContinuingRegistration;
    this.isActivePlan = isActivePlan;
    this.isExpiringServicePlan = isExpiringServicePlan;
    this.isExpiringAssignment = isExpiringAssignment;
    this.isPartialMandate = isPartialMandate;
  }

  get uniqueId() {
    return (
      this.servicePlanId +
      "+" +
      this.semesterCode +
      "+" +
      Math.random().toString(36).substring(8)
    );
  }

  get clientName() {
    return this.clientLastName + ", " + this.clientFirstName;
  }

  get formattedDob() {
    return formatDate(this.dateOfBirth);
  }

  get yearOfBirth() {
    return this.dateOfBirth && new Date(this.dateOfBirth).getFullYear();
  }

  get formattedOsis() {
    return formatOsis(this.osis);
  }

  get districtAdminFullName() {
    return Boolean(this.districtAdminId)
      ? this.districtAdminLastName + ", " + this.districtAdminFirstName
      : "";
  }

  get formattedNextMeetingScheduledDate() {
    return this.nextMeetingScheduledDate
      ? formatDate(this.nextMeetingScheduledDate)
      : "";
  }

  get formattedServicePlanStartDate() {
    return this.servicePlanStartDate
      ? formatDate(this.servicePlanStartDate)
      : "";
  }

  get formattedServicePlanEndDate() {
    return this.servicePlanEndDate ? formatDate(this.servicePlanEndDate) : "";
  }

  get formattedMandate() {
    return Boolean(this.frequency) && Boolean(this.durationMinutes)
      ? this.frequency + " x " + this.durationMinutes
      : "";
  }

  get tenTwelveMonth() {
    if (this.isSummerSemesterIncluded === false) return "10";
    if (this.isSummerSemesterIncluded === true) return "12";
    return "";
  }

  get providerFullName() {
    return Boolean(this.providerId)
      ? this.providerLastName + ", " + this.providerFirstName
      : "";
  }

  get formattedApprovalStartDate() {
    return Boolean(this.approvalStartDate)
      ? formatDate(this.approvalStartDate)
      : "";
  }

  get formattedApprovalEndDate() {
    return Boolean(this.approvalEndDate)
      ? formatDate(this.approvalEndDate)
      : "";
  }

  get formattedFAD() {
    return Boolean(this.firstAttendDate)
      ? formatDate(this.firstAttendDate)
      : "";
  }

  get formattedFADSubmitted() {
    return Boolean(this.firstAttendDateSubmittedAt)
      ? formatDate(this.firstAttendDateSubmittedAt)
      : "";
  }
  get isPendingAssignment() {
    return (
      (this.servicePlanEndDate == null ||
        new Date(this.servicePlanEndDate) >= new Date()) &&
      this.assignmentId == null
    );
  }
  get isPendingApproval() {
    return this.assignmentId != null && this.approvalStartDate == null;
  }
  get isAwaitingFADSubmission() {
    return (
      this.firstAttendDate != null && this.firstAttendDateSubmittedAt == null && !this.isContinuingRegistration
    );
  }
  get isCurrentAssignment() {
    return (
      this.approvalStartDate != null &&
      this.approvalEndDate != null &&
      new Date(this.approvalStartDate) <= new Date() &&
      new Date(this.approvalEndDate) >= new Date() &&
      this.actualEndDate == null
    );
  }
}
